import { Container, Sprite } from 'pixi.js';
import { Tween, Easing } from '@tweenjs/tween.js';
import { EVENTS } from '../lib/constants';

class StickyWilds extends Container {
	holder = null;
	wildsConfig = [
		[0, 0, 0],
		[0, 0, 0],
		[0, 0, 0],
		[0, 0, 0],
		[0, 0, 0]
	];

	wilds = [
		[null, null, null],
		[null, null, null],
		[null, null, null],
		[null, null, null],
		[null, null, null]
	];

	configs = [];

	constructor(cfg) {
		super();
		this.config = cfg;

		let result = this.config.icons.filter((icon) => icon.isWild);

		if (result == null || result.length === 0) {
			throw new Error('No wild in config');
		}
		//this.wildConfig
		for (let i = 0; i < 5; i++) {
			var wc = JSON.parse(JSON.stringify(result[0]));
			wc.IconClass = result[0].IconClass;
			wc.Fg2Class = result[0].Fg2Class;
			wc.animation.fg2Index = i;
			wc.iconBg = wc.iconBgBonus;
			wc.animation.bg = wc.animation.bonusBg;
			wc.isSticked = true;
			this.configs.push(wc);
		}
		//bonus_wild_bg
		this.holder = new Sprite();
		this.addChild(this.holder);

		window.addEventListener(EVENTS.REEL_STARTED, this, false);
	}

	handleEvent(evt) {
		if (evt.type === EVENTS.REEL_STARTED) {
			for (let i = 0; i < this.wilds.length; i++) {
				for (let j = 0; j < this.wilds[i].length; j++) {
					if (this.wilds[i][j] !== null) {
						this.wilds[i][j].fg.gotoAndStop(0);
						this.wilds[i][j].fg2.stop();
					}
				}
			}
		}
	}

	getWildsCount(cfg) {
		let wcnt = 0;
		for (let i = 0; i < cfg.length; i++) {
			for (let k = 0; k < cfg[i].length; k++) {
				wcnt = wcnt + cfg[i][k];
			}
		}
		return wcnt;
	}

	setWilds(wildsConfig, mult) {
		let current_frame = 0;
		if (this.holder.children.length > 0) {
			current_frame = this.holder.children[0].bg.currentFrame;
		}
		while (this.holder.children[0]) {
			this.holder.removeChild(this.holder.children[0]);
		}

		let needAnim =
			this.getWildsCount(this.wildsConfig) !== this.getWildsCount(wildsConfig);

		this.wildsConfig = wildsConfig;
		var wc = this.configs[mult - 1];

		for (let i = 0; i < this.wildsConfig.length; i++) {
			const col = this.wildsConfig[i];
			for (let t = 0; t < col.length; t++) {
				//bonus_wild_bg
				const w = col[t];
				if (w === 1) {
					wc.current_frame = current_frame;
					// let item = new wc.IconClass(wc, false, false);
					let item = new wc.IconClass(wc, false, false, false, {
						col: i,
						row: t
					});
					item.x = this.config.iconWidth * i;
					item.y = this.config.iconHeight * t;

					if (this.wilds[i][t] == null) {
						//item.alpha = 0;
					}

					item.bg.alpha = 1;
					//item.frame.alpha = 1
					this.wilds[i][t] = item;
					//item.animateFrame(0)
					// this.fg.scale.set((wc.animation.fg.scale.x, this.item.animation.fg.scale.y));
					if (needAnim) {
						item.fg2.animate();
						item.fg.anchor.set(0.5, 0.5);
						item.fg.x = item.fg.width / 2 + wc.animation.fg.offsetX;
						item.fg.y = item.fg.height / 2 + wc.animation.fg.offsetY;
						new Tween(item.fg.scale)
							.to(
								{
									x: wc.animation.fg.scale.x + 0.2,
									y: wc.animation.fg.scale.y + 0.2
								},
								150
							)
							.easing(Easing.Quadratic.Out)
							.onComplete(() => {
								new Tween(item.fg.scale)
									.to(
										{ x: wc.animation.fg.scale.x, y: wc.animation.fg.scale.y },
										450
									)
									.delay(300)
									.easing(Easing.Back.Out)
									.start();
							})
							.start();
					}

					this.holder.addChild(item);
				}
			}
		}
	}
}

export default StickyWilds;
